import { 
        InfoContainer, 
        InfoContainer2,
        InfoWrapper, 
        InfoRow, 
        Column1, 
        Column2,
        Column3,
        TextWrapper, 
        TextWrapper2, 
        TopLine, 
        Heading, 
        Heading2,
        Subtitle, 
        Subtitle2, 
        ImgWrap, 
        Img 
} from './InfoElements'

const InfoSection = ({ lightBg, imgStart, topLine, lightText, headline, headline2, darkText, description, description2, img, img2, alt }) => {
  return (
    <>
       <InfoContainer>
            <InfoWrapper id='about'>
                <InfoRow >
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading>{headline}</Heading>
                            <Subtitle>{description}</Subtitle>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer> 

        <InfoContainer2>
            <InfoWrapper id='services'>
                <InfoRow>
                    <Column3>
                        <ImgWrap>
                            <Img src={img2} alt={alt} />
                        </ImgWrap>
                    </Column3>
                    <Column2>   
                        <TextWrapper2>
                            <Heading2>{headline2}</Heading2>
                            <Subtitle2>{description2}</Subtitle2>
                        </TextWrapper2>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer2> 
    </>
  )
}

export default InfoSection